@if (loading) {
  <div class="chart-loading">
    <div class="loading-spinner"></div>
    <span class="loading-text">Carregando...</span>
  </div>
} @else if (isBrowser) {
  <div echarts [options]="chartOption" class="chart-container"></div>
} @else {
  <div class="chart-placeholder">
    <p>Carregando gráfico...</p>
  </div>
}
